import { connect } from 'react-redux'
import selector from 'modules/Auth/selectors'
import Page from 'modules/Page/Components/index'
import {
  getUserInfo,
  getUserRoles,
  getUserNotifications,
  markNotificationReadApi,
  getUserPermissions,
  signOut,
  checkOut,
} from 'modules/Auth/actions'
import { getInstituteInfo } from 'modules/Settings/actions'
import Settingselectors from 'modules/Settings/selectors'
import { getTPOMetrics } from '../../TPORequests/actions'
import {studentsMetricsData} from '../../Students/actions'
const mapStateToProps = state => ({
  userData: selector?.getUserInfo(state),
  userRole: selector?.getUserRoleList(state),
  instituteData: Settingselectors.getInstituteData(state),
  notificationData: selector.getNotifications(state),
})

const mapDispatchToProps = {
  getUserInfo,
  getUserRoles,
  getUserNotifications,
  getInstituteInfo,
  markNotificationReadApi,
  getUserPermissions,
  checkOut,
  signOut,
  getTPOMetrics,
  studentsMetricsData,
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
